import { Link as MuiLink, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import { FC } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import type { UnassignedPaddock } from '@/types/apiModels'
import { MonitoringPanel } from '../../../MonitoringPanel'

type StratificationQUsBottomBannerProps = {
  unassignedByYear: Record<string, UnassignedPaddock[]>
}

export const StratificationQUsBottomBanner: FC<StratificationQUsBottomBannerProps> = ({
  unassignedByYear,
}) => {
  const sortedYears = Object.keys(unassignedByYear).sort((a, b) => Number(a) - Number(b))

  return (
    <MonitoringPanel.Alert severity="warning" variant="standard">
      <MonitoringPanel.Alert.Title>
        Lotes con datos insuficientes para ingresar a QU
      </MonitoringPanel.Alert.Title>
      <MonitoringPanel.Alert.Body>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Año</TableCell>
              <TableCell>Lotes</TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedYears.map(year => {
              const names = unassignedByYear[year].map(paddock => paddock.paddockName).join(', ')
              return (
                <TableRow key={year}>
                  <TableCell>{year}</TableCell>
                  <TableCell>{names}</TableCell>
                  <TableCell>
                    <MuiLink component={RouterLink} to={`/management/data/${year}`}>
                      Editar DC
                    </MuiLink>
                  </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </MonitoringPanel.Alert.Body>
    </MonitoringPanel.Alert>
  )
}
